"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/app/components/ui/carousel";

import { cn } from "@/lib/utils";

export interface Listing {
  id: string;
  image: string;
  title: string;
  listingCard: React.ReactNode;
}

interface ListingSliderProps {
  heading: React.ReactNode;
  listings: Listing[];
  listingCard: React.ReactNode;
  className?: string;
}

export function ListingSlider({
  heading,
  listings,
  listingCard,
  className,
}: ListingSliderProps) {
  const itemClassName =
    listings.length < 3
      ? "basis-full pl-4 sm:basis-1/2 md:basis-1/3 lg:basis-1/3"
      : "basis-7/8 min-[550px]:basis-5/8 md:basis-43/100 lg:basis-1/3 pl-4";

  return (
    <div className={cn("w-full max-w-full min-w-0 overflow-hidden", className)}>
      <Carousel
        opts={{
          align: "start",
          dragFree: true,
        }}
        className="w-full"
      >
        <div className="relative mb-4 flex items-end justify-between px-6 md:px-8">
          <div>{heading}</div>
          <div className="flex gap-2">
            <CarouselPrevious
              variant="ghost"
              size="icon"
              className="relative top-0 left-0 size-8 -translate-y-0 rounded-full border"
              aria-label="Nach links scrollen"
            >
              <ChevronLeft className="size-4" />
            </CarouselPrevious>
            <CarouselNext
              variant="ghost"
              size="icon"
              className="relative top-0 right-0 size-8 -translate-y-0 rounded-full border"
              aria-label="Nach rechts scrollen"
            >
              <ChevronRight className="size-4" />
            </CarouselNext>
          </div>
        </div>

        <CarouselContent className="mt-6 -ml-5 flex items-stretch pr-4 pb-4 pl-6 md:pl-8">
          {listings.map((listing) => (
            <CarouselItem
              key={listing.id}
              className={cn(itemClassName, "flex h-auto")}
            >
              <div className="flex h-full w-full">
                {listing.listingCard || listingCard}
              </div>
            </CarouselItem>
          ))}
          {/* Spacer für Padding rechts beim letzten Item */}
          <CarouselItem className="basis-1/100">
            <div className="w-4" aria-hidden="true" />
          </CarouselItem>
        </CarouselContent>
      </Carousel>
    </div>
  );
}
